import React, { memo } from 'react';

import { useTranslations } from 'utils/hooks';

import classes from './NotFoundPage.module.scss';

const NotFoundPage = () => {
  const translations = useTranslations();

  return (
    <div className={classes.NotFoundPage}>
      <p>
        <span className={classes.NotFoundErrorCode}>404 </span>
        {translations('notFound')}
      </p>
    </div>
  );
};

export default memo(NotFoundPage);
